import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LangCacheKey } from '@common/config';
import { getFromLocalStorage } from '@common/util';
import enUS from './locales/en-US';
import enES from './locales/en-Es';

const resources = {
  en: {
    translation: {
      ...enUS
    }
  },
  es: {
    translation: {
     ...enES
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getFromLocalStorage(LangCacheKey) || 'en', // 默认语言
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;